import React from 'react';
import PropTypes from 'prop-types';
import { st, classes } from './Pagination.st.css';

var Pagination = function Pagination(_ref) {
  var className = _ref.className,
      pages = _ref.pages;
  return /*#__PURE__*/React.createElement("div", {
    className: st(classes.root, className)
  }, pages.map(function (page) {
    return _withDotClass(page);
  }));
};

var _withDotClass = function _withDotClass(comp) {
  var className = comp.props.className;
  return /*#__PURE__*/React.cloneElement(comp, {
    className: st(classes.dot, className)
  });
};

Pagination.propTypes = {
  className: PropTypes.string
};
Pagination.displayName = 'Pagination';
export default Pagination;